export default {
  api: {
    name: {
      notNull: "Geef de factuurregel een naam",
    },
  },
}
